<template>
  <div>
    <com-dialog :visible.sync="visible" width="600px" title="电卡号">
      <div>
        <div class="flex items-center">
          <div class="form_item flex items-center">
            <div class="label">电卡号</div>
            <el-input v-model="form.cardNo"></el-input>
          </div>
        </div>
        <div class="flex items-center justify-end mt-15px">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { addCard } from '@/api/electric_card'

export default {
  data() {
    return {
      visible: false,
      title: '新增',
      form: {}
    }
  },
  methods: {
    baseForm() {
      return {
        form: {}
      }
    },
    handleUpdate() {
      update(this.form).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    handleAdd() {
      addCard(this.form).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    open() {
      this.visible = true
      this.form = {}
    },
    close() {
      this.visible = false
    },
    confirm() {
      this.handleAdd()
    }
  }
}
</script>

<style lang="scss" scoped>
.form_item {
  margin-bottom: 20px;
  .label {
    width: 100px;
    flex-shrink: 0;
    margin-right: 10px;
    text-align: right;
  }
  .input {
    .el-input__inner {
      width: 300px !important;
    }
  }

  .price_wrapper {
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    padding-left: 16px;
    .remove {
      position: absolute;
      top: -10px;
      right: -10px;
      cursor: pointer;
    }
  }
}
</style>
